import React, { FunctionComponent } from 'react';
import HelpStyles from '../../Help.module.scss';

const ChromeMobile: FunctionComponent = () => {
  return (
    <div className={HelpStyles.sharedHelpStyles}>
      <div className={HelpStyles.steps}>
        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>1</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Open Chrome app
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>2</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Tap the three dots menu (⋮) → <strong>Settings</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>3</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Under "Advanced," tap <strong>Site settings</strong> → <strong>Location</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>4</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Turn <strong>Location</strong> on or off
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>5</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              For specific sites, tap the listed site names to customize
            </p>
          </div>
        </div>
      </div>

      <div className={HelpStyles.tip}>
        <div className={HelpStyles.tipIcon}>💡</div>
        <div className={HelpStyles.tipContent}>
          <p className="fontFourteen poppins-regular text-gray">
            <strong>Tip:</strong> Make sure your device's location services are also enabled in Android settings.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChromeMobile;